import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { AlertController } from "ionic-angular";
import moment from "moment";
import { Subscription } from "rxjs";
import { authorizationTypeList, Config } from "../models";

@Component({
  selector: "patient-benefits-authorization",
  templateUrl: "patient-benefits-authorization.html",
})
export class PatientBenefitsAuthorizationComponent
  implements OnInit, OnDestroy
{
  @Input() auth: FormGroup;
  @Input() i: any;
  @Input() authorizations: FormArray;
  @Input() careType: string;

  authorizationTypeList = authorizationTypeList;

  authorizationTypeSelected: Config = null;
  minStartDateValue: any = { year: 1900, month: 1, day: 1 };
  maxStartDateValue: any;
  minEndDateValue: any = { year: 1900, month: 1, day: 1 };
  maxEndDateValue: any;
  authorizationsList: any[];
  updateValue: boolean = true;
  subscriptions: Subscription[] = [];

  constructor(private alertCtrl: AlertController) {}

  ngOnInit(): void {
    this.checkCareType();
    this.subscriptions.push(
      this.auth
        .get("authorizationType")
        .valueChanges.subscribe((v) => this.onAuthorizationTypeChanges(v))
    );
    this.subscriptions.push(
      this.auth
        .get("authorizationStart")
        .valueChanges.subscribe((v) => this.onEffectiveStartDateChanges(v))
    );
    this.subscriptions.push(
      this.auth
        .get("authorizationEnd")
        .valueChanges.subscribe((v) => this.onEffectiveEndDateChanges(v))
    );
    this.authorizationTypeSelected = this.authorizationTypeList.filter(
      (a) => a.value === this.auth.get("authorizationType").value
    )[0];
  }
  checkCareType() {
    if (this.careType && this.careType === "HOSPICE") {
      this.authorizationTypeList = [
        { name: "Other", value: "OTHER", disabled: false },
      ];
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((val) => val.unsubscribe());
  }

  onAuthorizationTypeChanges(v) {
    this.updateValue = true;
    this.authorizationTypeSelected = this.authorizationTypeList.filter(
      (a) => a.value === v
    )[0];
    const previousVal = this.auth.value.authorizationType;

    this.authorizations.controls.forEach((a, index) => {
      if (
        index !== this.i &&
        this.updateValue &&
        a.get("authorizationType").value === v
      ) {
        if (
          a.get("authorizationEnd").value === null ||
          a.get("authorizationEnd").value === ""
        ) {
          this.warningPopup(
            "Authorization type " +
              this.authorizationTypeSelected.name +
              " already exists with no end date.",
            "authorizationType",
            previousVal
          );
        } else if (
          moment(this.auth.get("authorizationStart").value).isSameOrAfter(
            moment(a.get("authorizationStart").value)
          ) &&
          moment(this.auth.get("authorizationStart").value).isSameOrBefore(
            moment(a.get("authorizationEnd").value)
          )
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationType",
            previousVal
          );
        } else if (
          moment(this.auth.get("authorizationEnd").value).isSameOrAfter(
            moment(a.get("authorizationStart").value)
          ) &&
          moment(this.auth.get("authorizationEnd").value).isSameOrBefore(
            moment(a.get("authorizationEnd").value)
          )
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationType",
            previousVal
          );
        } else if (
          moment(this.auth.get("authorizationStart").value).isSameOrBefore(
            moment(a.get("authorizationStart").value)
          ) &&
          moment(this.auth.get("authorizationEnd").value).isSameOrAfter(
            moment(a.get("authorizationEnd").value)
          )
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationType",
            previousVal
          );
        } else if (
          previousVal !== "" &&
          (this.auth.get("authorizationEnd").value === "" ||
            this.auth.get("authorizationEnd").value === null)
        ) {
          this.warningPopup(
            "There is another Authorization for this care type for this date. Please consider using different dates for the new authorization.",
            "authorizationType",
            previousVal
          );
        }
      }
    });
  }

  onEffectiveStartDateChanges(v) {
    this.updateValue = true;
    const previousVal = this.auth.value.authorizationStart;
    this.authorizations.controls.forEach((a, index) => {
      if (
        index !== this.i &&
        this.updateValue &&
        this.authorizationTypeSelected &&
        a.get("authorizationType").value ===
          this.authorizationTypeSelected.value
      ) {
        if (
          moment(v).isSameOrBefore(moment(a.get("authorizationEnd").value)) &&
          (a.get("authorizationEnd").value === null ||
            a.get("authorizationEnd").value === "")
        ) {
          this.warningPopup(
            "Authorization Type " +
              this.authorizationTypeSelected.name +
              " already exists with no end date.",
            "authorizationStart",
            previousVal
          );
        } else if (
          moment(v).isSameOrAfter(moment(a.get("authorizationStart").value)) &&
          moment(v).isSameOrBefore(moment(a.get("authorizationEnd").value))
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationStart",
            previousVal
          );
        } else if (
          moment(v).isSameOrBefore(moment(a.get("authorizationStart").value)) &&
          moment(this.auth.get("authorizationEnd").value).isSameOrAfter(
            moment(a.get("authorizationEnd").value)
          )
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationStart",
            previousVal
          );
        } else if (
          moment(v).isSameOrBefore(moment(a.get("authorizationEnd").value)) &&
          (this.auth.get("authorizationEnd").value === null ||
            this.auth.get("authorizationEnd").value === "")
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationStart",
            previousVal
          );
        }
      }
    });
  }

  onEffectiveEndDateChanges(v) {
    this.updateValue = true;
    const previousVal = this.auth.value.authorizationEnd
      ? this.auth.value.authorizationEnd
      : "";
    this.authorizations.controls.forEach((a, index) => {
      if (
        index !== this.i &&
        this.updateValue &&
        this.authorizationTypeSelected &&
        a.get("authorizationType").value ===
          this.authorizationTypeSelected.value
      ) {
        if (
          (a.get("authorizationEnd").value === null ||
            a.get("authorizationEnd").value === "") &&
          moment(v).isSameOrAfter(moment(a.get("authorizationStart").value))
        ) {
          this.warningPopup(
            "Authorization Type " +
              this.authorizationTypeSelected.name +
              " already exists with no end date.",
            "authorizationEnd",
            previousVal
          );
        } else if (
          moment(v).isSameOrAfter(moment(a.get("authorizationStart").value)) &&
          moment(v).isSameOrBefore(moment(a.get("authorizationEnd").value))
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationEnd",
            previousVal
          );
        } else if (
          moment(this.auth.get("authorizationStart").value).isSameOrBefore(
            moment(a.get("authorizationStart").value)
          ) &&
          moment(v).isSameOrAfter(moment(a.get("authorizationEnd").value))
        ) {
          this.warningPopup(
            "There is another authorization in this date range.",
            "authorizationEnd",
            previousVal
          );
        } else if (
          v === null &&
          previousVal !== "" &&
          moment(this.auth.get("authorizationStart").value).isSameOrBefore(
            moment(a.get("authorizationEnd").value)
          )
        ) {
          this.warningPopup(
            "There is another Authorization for this care type for this date. Please consider using different dates for the new authorization.",
            "authorizationEnd",
            previousVal
          );
        }
      }
    });
  }

  authTypeChanged(val: Config) {
    if (this.updateValue && val) {
      this.authorizationTypeSelected = val;
      this.auth.get("description").setValue("");
    }
    this.updateValue = true;
  }

  startDateChanged(val) {
    if (val !== null) {
      const m = moment(val);
      this.minEndDateValue = {
        year: m.year(),
        month: m.month() + 1,
        day: m.date(),
      };
    } else {
      this.minEndDateValue = { year: 1900, month: 1, day: 1 };
    }
  }

  endDateChanged(val) {
    if (val !== null) {
      const m = moment(val);
      this.maxStartDateValue = {
        year: m.year(),
        month: m.month() + 1,
        day: m.date(),
      };
    } else {
      this.maxStartDateValue = null;
    }
  }

  warningPopup(message: string, field: string, value: string) {
    const alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      title: "Warning",
      message: message,
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.updateValue = false;
            this.auth.get(field).setValue(value, { emitEvent: false });
            if (field === "authorizationType") {
              this.authorizationTypeSelected =
                this.authorizationTypeList.filter((a) => a.value === value)[0];
            }
          },
        },
      ],
    });
    alert.present();
  }

  allowOnlyNumbersAndLetters(e) {
    var regex = new RegExp("^[a-zA-Z0-9-]+$");
    // CO-3068 — was `e.wich` (typo): always undefined, so the keyCode/which
    // fallback path built a NUL char and blocked every valid keystroke in
    // browsers that populate keyCode/which but not `e.key`. Read `e.which`.
    var str = !e.key ? String.fromCharCode(e.which) : e.key;
    if (!regex.test(str)) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-benefits/patient-benefits-authorization/patient-benefits-authorization.ts